exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-item .icon{\r\n    margin-right: unset;\r\n}\r\n.media a {\r\n    color: #818c94;\r\n}\r\n\r\n.service-setting .select2-container {\r\n    width: 100% !important;\r\n}\r\n\r\n/* .list-group .media {\r\n    border-bottom: 1px solid #ede7e7;\r\n} */\r\n\r\n\r\n.media :hover{\r\n    background-color: rgb(206, 210, 210);   \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/service/service.css
// module id = ../../../../../src/app/pages/admin/icontact/setting/service/service.css
// module chunks = main